export default "__VITE_ASSET__CtPwGMlW__"